<div class="side-nav">
  <nav id="sidebar">
    <div class="heading">
      <div class="sidebar-header">
        <app-orca-logo
          [logoWidthRem]="4"
          [logoHeightRem]="4">
        </app-orca-logo>
      </div>
      <div *ngIf="isDemo" style="display: flex;align-items: center;justify-items: center; font-weight: bold;">
        <span>Demo</span>
      </div>
      <div *ngIf="isPreDemo" style="display: flex;align-items: center;justify-items: center; font-weight: bold;">
        <span>Pre-Demo</span>
      </div>
      <div *ngIf="isStaging" style="display: flex;align-items: center;justify-items: center; font-weight: bold;">
        <span>Staging</span>
      </div>
    </div>

    <div class="centered-column-container full-height">
      <div
        *ngIf="(currentService.fms && showService.fms)"
        data-qa="sidenav-organization"
        class="centered-column-container side-nav-menu-item"
        routerLinkActive="menu-active"
        routerLink="{{links.organization}}"
        queryParamsHandling="preserve">
        <app-all-icons [iconNameAndStyling]="'case-bag.svg; icon-size-1p875 white-12'"></app-all-icons>
        <span>Organization</span>
      </div>

      <div
        *ngIf="currentService.fms && showService.fms"
        data-qa="sidenav-fund"
        class="centered-column-container side-nav-menu-item"
        [ngClass]="{'opacity0p5 not-clickable': isFundsEmpty}"
        [class.menu-active]="isFundActive"
        queryParamsHandling="preserve"
        routerLink="{{links.fundPerformances}}">
        <app-all-icons [iconNameAndStyling]="'fund.svg; icon-size-1p875 white-12'"></app-all-icons>
        <span>Fund</span>
      </div>

      <div
        *ngIf="(currentService.fms && showService.fms)"
        data-qa="sidenav-investors"
        class="flex flex-col items-center justify-center side-nav-menu-item"
        routerLinkActive="menu-active"
        routerLink="{{links.investors}}"
        queryParamsHandling="preserve">
        <app-all-icons [iconNameAndStyling]="'organization.svg; icon-size-1p875 white-12'"></app-all-icons>
        <span>Investors</span>
      </div>

      <div
        *ngIf="currentService.fms && showService.fms && !isFundsEmpty"
        data-qa="sidenav-prediction-models"
        class="centered-column-container side-nav-menu-item"
        [class.menu-active]="showSubmenu.predictionModels.isStyleActive"
        (mouseenter)="activateDropDown()"
        (mouseleave)="deactivateDropDown()">
        <img src="/assets/svg/side-nav/Prediction_Models.svg" alt="Prediction models" />
        <span>Models</span>
        <div
          *ngIf="showSubmenu.predictionModels.isShown"
          class="menu-subgroup"
          routerLinkActive="menu-active"
          [ngClass]="{'menu-disabled not-clickable': isFundsEmpty}">

          <div
            data-qa="sidenav-prediction-models-fund-budget"
            class="submenu"
            routerLinkActive="submenu-active"
            queryParamsHandling="preserve"
            routerLink="{{links.fundBudgetModel}}"
            (click)="deactivateDropDown()">
            Fund budget
          </div>

          <div
            data-qa="sidenav-prediction-models-fund-strategy"
            class="submenu"
            routerLinkActive="submenu-active"
            queryParamsHandling="preserve"
            routerLink="{{links.fundStrategy}}"
            (click)="deactivateDropDown()">
            New fund modeling
          </div>

          <div
            data-qa="sidenav-prediction-models-commitment-allocation"
            class="submenu"
            routerLinkActive="submenu-active"
            queryParamsHandling="preserve"
            routerLink="{{links.followOnModel}}"
            (click)="deactivateDropDown()">
            Commitment allocation
          </div>

          <div
            data-qa="sidenav-prediction-models-portfolio-performance"
            class="submenu"
            routerLinkActive="submenu-active"
            queryParamsHandling="preserve"
            routerLink="{{links.irr}}"
            (click)="deactivateDropDown()">
            Performance prediction
          </div>

        </div>
      </div>
      <div *ngIf="showService.fms && currentService.fms && !isFundsEmpty"
        data-qa="sidenav-investor-report"
        class="centered-column-container side-nav-menu-item"
        routerLinkActive="menu-active"
        routerLink="{{links.investorReport}}"
        queryParamsHandling="preserve">
        <app-all-icons [iconNameAndStyling]="'paper-plane.svg; white-12 icon-size-1p875'"></app-all-icons>
        <span>Reports</span>
      </div>
      <div *ngIf="showService.marketAnalysis" queryParamsHandling="preserve" class="w-full">
        <div data-qa="market-by-vintage"
          class="centered-column-container side-nav-menu-item"
          [class.menu-disabled]="isFundsEmpty"
          queryParamsHandling="preserve"
          routerLinkActive="menu-active"
          routerLink="{{links.marketAnalysisByVintage}}">
          <app-all-icons
            [iconNameAndStyling]="'performance-by-vintage.svg;icon-size-1p5'">
          </app-all-icons>
          <span [class.menu-disabled]="isFundsEmpty">Vintage</span>
        </div>
        <div data-qa="market-by-industry"
          class="centered-column-container side-nav-menu-item"
          [class.menu-disabled]="isFundsEmpty"
          queryParamsHandling="preserve"
          routerLinkActive="menu-active"
          routerLink="{{links.marketAnalysisByIndustry}}">
          <app-all-icons
            [iconNameAndStyling]="'performance-by-industry.svg;icon-size-1p5'">
          </app-all-icons>
          <span [class.menu-disabled]="isFundsEmpty">Industry</span>
        </div>
        <div
          data-qa="market-by-stock"
          class="centered-column-container side-nav-menu-item"
          queryParamsHandling="preserve"
          routerLinkActive="menu-active"
          routerLink="{{links.marketAnalysisByStock}}">
          <app-all-icons
            [iconNameAndStyling]="'public-market.svg;icon-size-1p5'">
          </app-all-icons>
          <span>Public</span>
        </div>
     </div>
      <ng-container *ngIf="showService.kpi">
        <div data-qa="kpi-metrics"
          class="centered-column-container side-nav-menu-item"
          queryParamsHandling="preserve"
          routerLinkActive="menu-active" routerLink="{{links.crossPortfolio}}">
          <app-all-icons [iconNameAndStyling]="'portfolio.svg; icon-size-1p875 white-12'"></app-all-icons>
          <span>Cross-portfolio</span>
        </div>
        <div data-qa="kpi-companies"
          class="centered-column-container side-nav-menu-item"
          queryParamsHandling="preserve"
          routerLinkActive="menu-active" routerLink="{{links.kpiCompanies}}">
          <img src="/assets/svg/side-nav/Prediction_Models.svg" alt="Prediction models" />
          <span>Company KPI's</span>
        </div>
        @if (isAdminChosen){
          <div data-qa="kpi-bulk-request"
               class="centered-column-container side-nav-menu-item"
               queryParamsHandling="preserve"
               routerLinkActive="menu-active" routerLink="{{links.bulkRequest}}">
            <app-all-icons [iconNameAndStyling]="'kpi-bulk-request.svg; icon-size-1p875 white-12'"></app-all-icons>
            <span>Request & submissions</span>
          </div>
        }
      </ng-container>
      <ng-container *ngIf="showService.financialStatement">
        <div data-qa="fs-wp"
          class="centered-column-container side-nav-menu-item"
          queryParamsHandling="preserve"
          routerLinkActive="menu-active" routerLink="{{links.fsWorkingPapers}}">
          <img src="/assets/svg/side-nav/assembly-v2.svg" alt="Working papers" />
          <span>Working paper</span>
        </div>
        <div *ngIf="hasFs"
          data-qa="fs-fin-anal"
          class="centered-column-container side-nav-menu-item"
          queryParamsHandling="preserve"
          routerLinkActive="menu-active" routerLink="{{links.fsFinancialAnalytics}}">
          <img src="/assets/svg/side-nav/schedule_of_investments.svg" alt="Fin & analytics" />
          <span>Financials & analytics</span>
        </div>
        <div *ngIf="hasFs && isFsForFund"
          data-qa="fs-cap-acc"
          class="centered-column-container side-nav-menu-item"
          queryParamsHandling="preserve"
          routerLinkActive="menu-active" routerLink="{{links.fsCapitalAccounts}}">
          <img src="/assets/svg/side-nav/capital_account.svg" alt="Cap acc" />
          <span>Capital accounts</span>
        </div>
      </ng-container>

      <div
        data-qa="sidenav-switch-software"
        routerLinkActive="menu-active"
        routerLink="{{links.entrance}}"
        queryParamsHandling="preserve"
        id="switch-software"
        class="last-item centered-column-container side-nav-menu-item"
        (mouseenter)="activateTooltip('switch-software', 'Switch software')"
        (mouseleave)="toolTipSettings.show = false">
        <img src="/assets/svg/side-nav/other-services.svg" alt="other services" />
      </div>
    </div>
  </nav>
</div>

<app-tooltip *ngIf="toolTipSettings.show"
  [coordinates]="toolTipSettings.coordinates"
  [title]="toolTipSettings.title"
  [xShift]="'2rem'"
  [yShift]="'-1.5rem'"
/>

